const { location } = require('@wix/site-location');

function isElementExistOnPage(element) {
  if (typeof element === 'object' && !Array.isArray(element) && element?.id) {
    return true;
  }
  if (Array.isArray(element) && element.length) {
    return true;
  }
  return false;
}

async function isProductPage() {
  const url = await location.url();
  return url && url.includes('product-page');
}

module.exports = {
  isElementExistOnPage,
  isProductPage,
};
